<template>
  <div>
    <div :class="{ loginerro: true, isLoginerro: !noLoginerro }">
      <div class="loginerro_log"></div>
      <span>账号或密码错误</span>
      <div class="loginerro_btn" @click="hideBtn"></div>
    </div>

    <el-input placeholder="请输入账号" prefix-icon="el-icon-user" :class="{ input1: true, input1_erro: usererro }" clearable
      v-model.trim="userName">
    </el-input>

    <div :class="{ dialog: true, nodialog: !usererro }">请输入账号</div>

    <el-input placeholder="请输入密码" prefix-icon="el-icon-lock" :class="{ input2: true, input2_erro: passworderro }"
      show-password v-model.trim="password">
    </el-input>

    <div :class="{ dialog2: true, nodialog2: !passworderro }">请输入密码</div>

    <div class="forwrad">
      <el-checkbox v-model.trim="checkedstatus" class="remember">记住密码</el-checkbox>
      <span @click="forget()">忘记密码?</span>
    </div>

    <el-button class="loginBtn" :loading="isLoginLoading" @click="onSubmit">登录</el-button>
    <div class="toreg">
      <span>没有账号？</span>
      <span @click="tologin()">马上注册使用>></span>
    </div>
  </div>
</template>

<script>
import { login } from "@/services/user";
import md5 from "js-md5";
import { locale } from "moment";
import { addDynamicRoutes } from '../../../router/index'
import {
  listResourceTree,
  bankSyncLog,
  bankSyncClick,
} from "@/api/permissions.js";
import systemclass from "@/api/systemclassification";
export default {
  data() {
    return {
      userName: "",
      password: "",
      checkedstatus: true, //
      usererro: false, // 用户名提示
      passworderro: false, // 密码提示
      noLoginerro: true, // 登录信息提示
      // 用于保存加载状态
      isLoginLoading: false,
      loginForm: {}, // 登录表单
    };
  },
  methods: {
    // 注册
    tologin() {
      this.$router.push({ name: "register" });
    },
    // 忘记密码
    forget() {
      this.$router.push({ name: "forget" });
    },
    test(e) {
      //  console.log(e);
      if (e.keyCode == 13) {
        this.onSubmit();
      }
    },
    // 登录
    async onSubmit() {
      if (this.userName === "") {
        this.usererro = true;
      } else {
        this.usererro = false;
      }
      if (this.password === "") {
        this.passworderro = true;
      } else {
        this.passworderro = false;
      }
      if (this.usererro === true || this.passworderro === true) {
        this.noLoginerro = true;
      }

      //判断复选框是否被勾选 勾选则调用配置cookie方法
      if (this.checkedstatus == true) {
        // console.log("checked == true");
        //传入账号名，密码，和保存天数3个参数
        this.setCookie(this.userName, this.password, 2);
      } else {
        // console.log("清空Cookie");
        //清空Cookie
        this.clearCookie();
      }

      // 登录表单数据
      this.loginForm.username = this.userName;
      localStorage.setItem("pws", this.password);
      this.loginForm.password = md5(this.password);
      this.loginForm.source = "khy";
      // 登录请求
      const type = this.checkStrengthPass(this.password); // 弱密码校验
      console.log(type, this.password);
      try {
        this.isLoginLoading = true;
        const { data } = await login(this.loginForm);
        this.isLoginLoading = false;
        if (data.Status === 200) {
          if (type == true) {
            // 这里是校验强密码通过
            this.$message.success("登录成功");
            // 将用户信息存储到 Vuex 中
            let obj = JSON.stringify(data.Data);
            this.$store.commit("setUserList", obj);
            this.$store.commit("setUser", data.Data.guid);
            this.$store.commit("setUserID", data.Data.userID);
            this.$store.commit("setHid", data.Data.hid);
            this.getEffectiveInfo(data.Data);
            addDynamicRoutes()
            // 题库图片转码地址存储
            // 根据可能存储的 redirect 数据进行跳转设置
            if (
              window.location.hostname.includes("localhost") ||
              window.location.hostname.includes("121.40.220.32:8020")
            ) {
              // 测试环境
              sessionStorage.setItem("ImgUrl", "http://customimgt.tibosi.com");
            } else if (window.location.hostname.includes("newkhy.tibosi.com")) {
              // 正式环境
              sessionStorage.setItem("ImgUrl", "http://customimg.tibosi.com");
            }
            // sessionStorage.setItem('ImgUrl',)
            if (data.Data.userType === "student") {
              // this.$message.error("考生请使用医考拉登录");
              this.$router.push({
                path: "/Examination",
                query: { type: "ks" },
              });
              return;
            }
            this.$router.push(this.$route.query.redirect || "/");
            // 检测是否有题库更新提示
            this.detectionBank();
            // this.getpermissions();//测试暂时fdsasdsxsswwffdasdaw
          } else {
            this.$alert(
              "检测到当前账号密码强度较弱，请修改密码后再登陆",
              "提示",
              {
                confirmButtonText: "确定",
                callback: (action) => {
                  this.$router.push({
                    path: "/passwrod", //跳转的路径
                    query: {
                      guid: data.Data.guid,
                      userID: data.Data.userID,
                      user: this.userName,
                    },
                  });
                },
              }
            );
          }
        } else if (data.Status === 202) {
          this.$message.error("用户不存在或者密码错误");
        } else if (data.Status === 308) {
          console.log(1);
          // 初始默认进来是弱密码，前端校验确定  checkPsw 0 弱  1强
        }
      } catch (error) {
        // 设置校验失败后的功能（提示）
        // console.log(error, "没有通过校验");
      }
    },
    // 校验登陆密码是否强密码
    checkStrengthPass(text) {
      // let text = "Kp@3445339779";
      // 12.15 产品更改规则，必须是大写小写且数字
      const textStrong = /(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d){6,20}/;
      if (textStrong.test(text)) {
        return true;
      } else {
        return false;
      }
      // let minreg = /^\d+$/; //纯数字
      // let minreg2 = /^[A-Za-z]+$/; //纯字母
      // if (text.length < 6 || minreg.test(text) || minreg2.test(text)) {
      //   return false;
      // } else {
      //   return true;
      // }
      // return;
      // let minreg3 = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,}$/; //纯数字或纯字母且低于六位视为弱密码不让通过
      // if (minreg3.test(text)) {
      //   return true;
      // } else {
      //   return false;
      // }
    },
    // 题库更新提示
    async detectionBank() {
      let obj = {
        //  guid: JSON.parse(localStorage.getItem("userlist")).guid,
        // userID: JSON.parse(localStorage.getItem("userlist")).userID,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
      };
      const { data } = await bankSyncLog(obj);
      if (data.Status == 200) {
        let updateTime = this.$moment(data.Data.updateTime).format(
          "YYYY年MM月DD日 HH:mm:ss"
        );
        const absolute = data.Data.lastTestNum - data.Data.testNum;
        if (data.Data.isShow == true) {
          this.$alert(
            `<div ><p class='pl24'>尊敬的用户您好。为了给您提供更优质的考培服务，我们已于${updateTime}针对题库中错题、旧题进行了更新，共计己完成更新<span class="red">${Math.abs(
              absolute
            )}</span>题。</p><p class='pl24'>如您对本次更新存在疑问，欢迎咨询您的客户经理，我们将竭成为您服务，感谢您对我们的支持。</p></div>`,
            "题库更新",
            {
              confirmButtonText: "确定",
              customClass: 'w800',
              dangerouslyUseHTMLString: true,
              callback: async (action) => {
                const argument = {
                  hid: JSON.parse(localStorage.getItem("userlist")).hid,
                  logId: data.Data.id,
                };
                const res = await bankSyncClick(argument);
                console.log(res);
              },
            }
          );
        }
      } else {
        this.$message.error(data.Data);
      }
      console.log(data);
    },
    // 获取系统有效期信息
    async getEffectiveInfo(params) {
      let obj = {
        OperatUserID: params.userID,
        guid: params.guid,
        hid: params.hid,
      };
      const { data } = await systemclass.timeCheck(obj);
      if (data.Status == 200) {
        sessionStorage.setItem("xufeiInfo", JSON.stringify(data.Data));
      } else {
        this.$message.error(data.Msg);
      }
    },
    // 隐藏提示框
    hideBtn() {
      this.noLoginerro = true;
    },
    //设置cookie
    setCookie(c_name, c_pwd, exdays) {
      var exdate = new Date(); //获取时间
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      //字符串拼接cookie
      window.document.cookie =
        "userName" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
      window.document.cookie =
        "userPwd" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
    },
    //读取cookie
    getCookie: function () {
      if (document.cookie.length > 0) {
        // console.log("获取cookie document.cookie", document.cookie);
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //      console.log("arr2", arr2)
          //判断查找相对应的值
          if (arr2[0] == "userName") {
            this.userName = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "userPwd") {
            this.password = arr2[1];
          }
        }
      }
      if (this.userName != "" && this.password != "") {
        this.checkedstatus = true;
      } else {
        this.checkedstatus = false;
      }
    },
    //清除cookie
    clearCookie: function () {
      this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
    },
    getpermissions() {
      // console.log(localStorage.getItem("user"));
      let pamas = {
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        userId: JSON.parse(localStorage.getItem("userlist")).userID,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        type: "1",
      };
      listResourceTree(pamas)
        .then((res) => {
          let path = res.data.Data[0].children[0].route_name;
          this.$router.push(path);
          this.$root.$reflech();
          return new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve();
            }, 1000);
          });
        })
        .then(() => {
          location.reload();
        });
    },
  },
  created() {
    window.addEventListener("keydown", this.test);
  },
  beforeDestroy() {
    // 实例销毁之前对点击事件进行解绑
    window.removeEventListener("keydown", this.test);
  },
  mounted() {
    this.getCookie();
  },
};
</script>

<style lang="scss" scoped>
.loginerro {
  width: 450px;
  height: 30px;
  background: #fff1f0;
  border: 1px solid #ffccc7;
  opacity: 0;
  border-radius: 5px;
  display: flex;
  align-items: center;
  padding-left: 16px;
  padding-right: 16px;

  //transition: all 0.1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  // transform: translateX(10px);
  .loginerro_log {
    width: 14px;
    height: 14px;
    background-image: url(../../../assets/Shape.png);
  }

  @keyframes bounce-in {
    0% {
      transform: rotate(1deg);
    }

    15% {
      transform: rotate(-1deg);
    }

    25% {
      transform: rotate(1deg);
    }

    50% {
      transform: rotate(-1deg);
    }

    75% {
      transform: rotate(1deg);
    }

    100% {
      transform: rotate(0deg);
    }
  }

  span {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.65);
    margin-left: 10px;
  }

  .loginerro_btn {
    width: 8px;
    height: 8px;
    background-image: url(../../../assets/Shape2.png);
    margin-left: 270px;
    cursor: pointer;
  }
}

.isLoginerro {
  opacity: 1;
  transition: all 1s cubic-bezier(1, 0.5, 0.8, 1);
  animation: bounce-in 2s;
  //    transform: translateX(10px);
}

.input1 {
  margin-top: 10px;

  ::v-deep .el-input__inner {
    height: 50px;
    padding-left: 40px;

    &::-webkit-input-placeholder {
      width: 90px;
      height: 25px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 32px;
      color: rgba(0, 0, 0, 0.25);
    }
  }

  ::v-deep.el-input__icon {
    font-size: 18px;
    width: 35px;
  }
}

.input1_erro {
  ::v-deep .el-input__inner {
    border: 1px solid #ff0000;
  }
}

.input2_erro {
  ::v-deep.el-input__inner {
    border: 1px solid #ff0000;
  }
}

.input2 {
  margin-top: 10px;

  ::v-deep .el-input__inner {
    height: 50px;
    padding-left: 40px;

    &::-webkit-input-placeholder {
      width: 90px;
      height: 25px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 32px;
      color: rgba(0, 0, 0, 0.25);
    }
  }

  ::v-deep.el-input__icon {
    font-size: 18px;
    width: 35px;
  }
}

.dialog {
  width: 65px;
  height: 18px;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 32px;
  color: #ff0000;
}

.nodialog {
  opacity: 0;
}

.nodialog2 {
  opacity: 0;
}

.dialog2 {
  width: 65px;
  height: 18px;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 32px;
  color: #ff0000;
}

.forwrad {
  margin-top: 15px;

  span {
    float: right;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #1890ff;
    opacity: 1;
    cursor: pointer;
  }
}

.loginBtn {
  //transform: translate(10px);
  margin-top: 20px;
  outline: none;
  width: 450px;
  height: 52px;
  border: none;
  border-radius: 4px;
  background-color: #1890ff;
  color: rgb(255, 255, 255);
  letter-spacing: 8px;
  cursor: pointer;
  font-weight: 600;
  font-size: 20px;

  &:hover {
    background-color: #274ab1;
  }
}

.toreg {
  font-size: 14px;
  font-family: " Microsoft YaHei";
  margin-left: 10px;
  margin-top: 20px;

  span {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    line-height: 28px;
    color: #999999;

    &:nth-child(2) {
      width: 135px;
      height: 25px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 28px;
      color: #1890ff;
      float: right;
      cursor: pointer;
    }
  }
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  font-size: 24px;
  color: #fff;
}

::v-deep .el-dialog__header {
  height: 55px;
  background: #0084ea;
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 16px;
  letter-spacing: 2px;
  font-family: PingFang SC;
  box-sizing: border-box;
  text-align: center;

  .el-dialog__title {
    color: #fff;
  }
}

::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

::v-deep .el-dialog__footer {
  padding: 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-content: center;

  button {
    width: 80px;
    height: 40px;
    border-radius: 2px;
    color: #fff;
    font-size: 14px;

    &:nth-child(1) {
      background: #c4c4c4;
      margin-right: 10px;
    }

    &:nth-child(2) {
      background: #0084ea;
    }
  }
}

.modify {
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }

  ::v-deep .dialog-footer {
    margin-bottom: 30px;
    width: 100% !important;
  }

  ::v-deep.el-dialog__footer {
    justify-content: left !important;
  }

  span>button:nth-child(3) {
    margin-left: 50px;
  }

  ::v-deep .el-dialog__footer span>button:nth-child(2) {
    margin-left: 0;
  }

  .mian {
    display: flex;
    align-items: center;

    p {
      //   width: 120px;
      line-height: 24px;
      padding-left: 24px;
    }

    ::v-deep .el-input__inner {
      width: 280px;
    }
  }

  .el-dialog__footer span>button {
    margin-top: 10px;
  }

  ::v-deep .el-dialog {
    width: 300px;
    border-radius: 5px 5px 0px 0px;

    .input_layout {
      display: flex;

      >.el-form-item {
        flex: 1;
        display: flex;
        align-content: center;

        ::v-deep .el-input {
          width: 420px;
        }
      }
    }
  }
}

::v-deep .el-message-box {
  min-width: 400px !important;
}
</style>
<style lang="scss">
.pl24 {
  font-size: 20px;
  line-height: 26px !important;
  text-indent: 38px !important;
  padding-left: 12px !important;
  margin-top: 12px !important;
  letter-spacing: 2px !important;
}

.red {
  color: red !important;
  font-weight: bold;
}

.w800 {
  width: 800px !important;
}
</style>
